import HTTP from "../utils/HTTP";

class SubscriptionService {
  /**
   * Create a subscription for sponsoring a kid
   * @param {Object} data - Subscription data
   * @returns {Promise} API response
   */
  createSubscription = (data) => {
    return HTTP.post("/subscription/create", data);
  };

  /**
   * Fetch all subscriptions for a mentor
   * @param {number} mentor_id - Mentor's user ID
   * @returns {Promise} API response with subscriptions list
   */
  fetchMentorSubscriptions = (mentor_id) => {
    return HTTP.get("/subscription/mentor", {
      params: { mentor_id },
    });
  };

  /**
   * Fetch subscription details by ID
   * @param {number} id - Subscription ID
   * @returns {Promise} API response with subscription details
   */
  fetchSubscriptionById = (id) => {
    return HTTP.get(`/subscription/${id}`);
  };

  /**
   * Fetch payments for a subscription
   * @param {number} subscription_id - Subscription ID
   * @returns {Promise} API response with payments list
   */
  fetchSubscriptionPayments = (subscription_id) => {
    return HTTP.get(`/subscription/${subscription_id}/payments`);
  };

  /**
   * Cancel a subscription
   * @param {number} subscription_id - Subscription ID
   * @param {boolean} cancel_at_cycle_end - If true, cancels at end of current cycle
   * @returns {Promise} API response
   */
  cancelSubscription = (subscription_id, cancel_at_cycle_end = false) => {
    return HTTP.post("/subscription/cancel", {
      subscription_id,
      cancel_at_cycle_end,
    });
  };

  /**
   * Pause a subscription
   * @param {number} subscription_id - Subscription ID
   * @returns {Promise} API response
   */
  pauseSubscription = (subscription_id) => {
    return HTTP.post("/subscription/pause", { subscription_id });
  };

  /**
   * Resume a paused subscription
   * @param {number} subscription_id - Subscription ID
   * @returns {Promise} API response
   */
  resumeSubscription = (subscription_id) => {
    return HTTP.post("/subscription/resume", { subscription_id });
  };

  /**
   * Create a subscription plan for a kid (usually admin only)
   * @param {Object} data - Plan data
   * @returns {Promise} API response
   */
  createPlan = (data) => {
    return HTTP.post("/subscription/plan/create", data);
  };

  /**
   * Fetch all plans for a kid
   * @param {number} kid_id - Kid ID
   * @returns {Promise} API response with plans
   */
  fetchKidPlans = (kid_id) => {
    return HTTP.get(`/subscription/plans/${kid_id}`);
  };

  /**
   * Verify and record payment after successful Razorpay checkout
   * This creates a payment record for receipt generation
   * @param {Object} data - Payment verification data
   * @returns {Promise} API response with payment details
   */
  verifyAndRecordPayment = (data) => {
    return HTTP.post("/subscription/verify-payment", data);
  };

  /**
   * Release unpaid subscription checkout after cancel/failure/abandon
   */
  abandonCheckout = (data) => {
    return HTTP.post("/subscription/abandon-checkout", data);
  };
}

export default new SubscriptionService();
